module.exports = ko;


/*****************
 ** WEBPACK FOOTER
 ** external "ko"
 ** module id = 3
 ** module chunks = 0 1 2 3 4 5 6 7 8
 **/